module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9Ikdyb3VwIDIzODIzMiI+CjxyZWN0IGlkPSJSZWN0YW5nbGUgMzQ2MjQ3OTciIHg9IjAuMjcxNDg0IiB5PSI4LjU2MzcyIiB3aWR0aD0iMTkuMjI5IiBoZWlnaHQ9IjMuMzE1MzUiIHJ4PSIxLjY1NzY3IiBmaWxsPSIjMDA3OEE3Ii8+CjxyZWN0IGlkPSJSZWN0YW5nbGUgMzQ2MjQ3OTgiIHg9IjguMjI4NTIiIHk9IjE5LjgzNTkiIHdpZHRoPSIxOS4yMjkiIGhlaWdodD0iMy4zMTUzNSIgcng9IjEuNjU3NjciIHRyYW5zZm9ybT0icm90YXRlKC05MCA4LjIyODUyIDE5LjgzNTkpIiBmaWxsPSIjMDA3OEE3Ii8+CjwvZz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/RF_assets/icons/plus-blue.svg
// module id = aSmk
// module chunks = 28